import React from 'react';
import PropTypes from 'prop-types';

import { Route, Redirect } from 'react-router-dom';

import { useSelector } from 'react-redux';


export const PrivateRoute = ({
    permission,
    component: Component,
    ...rest
}) => {

    const { isLoggedIn } = useSelector( state => state.auth);

    return (
        <Route { ...rest }
            component={ (props) => (
                ( isLoggedIn && permission )
                    ? ( <Component { ...props } /> )
                    : ( <Redirect to="/login" /> )
            )}
        
        />
    )
}

PrivateRoute.propTypes = {
    component: PropTypes.func.isRequired,
    permission : PropTypes.bool.isRequired
}
